import Icon from '../../UI/Icon/Icon';
import { isReadOnly as _isReadOnly } from '../../../Utils/sharing';
import SheetSummary from './SheetSummary';
import { parseFileSize } from '@/Utils/parseFileSize';
import { parseRowCount } from '@/Utils/DatasetTree/parseRowCount';

import { useCurrentFile } from '@/hooks/useCurrentFile';

const SheetStats = () => {
  const currentFile = useCurrentFile();
  const { metadata } = currentFile || {};

  const fileName = metadata?.FileName || '';
  const fileDescription = currentFile?.Note || '';
  const isReadOnly = _isReadOnly(currentFile);
  const fileSizeBytes = metadata?.FileSize || 0;
  const fileSize = fileSizeBytes ? parseFileSize(fileSizeBytes) : '0 size';
  const fileRowCount = metadata?.FileRows || 0;
  const fileRows = parseRowCount(fileRowCount);
  const columnCount = metadata?.FieldsTypes?.length || 0;

  const getTableLabel = (value) => {
    switch (value) {
      case 'Int64':
      case 'UInt64':
      case 'Float64':
        return 'Number';
      case 'Boolean':
        return 'Boolean';
      case 'DateTime':
      case 'DateTime64':
        return 'Date';
      case 'String':
      case 'EmailAddress':
        return 'Text';
      default:
        return 'Other';
    }
  };

  const countColumnTypes = () => {
    const categorizedColumnCount = {
      Number: 0,
      Boolean: 0,
      Date: 0,
      Text: 0,
      Other: 0,
    };
    if (!metadata?.FieldsTypes) return categorizedColumnCount;

    const typesList = metadata.FieldsTypes;
    Object.entries(typesList).forEach(([key, value]) => {
      if (key == 0) return; // Skip the row number column
      const label = getTableLabel(value);
      categorizedColumnCount[label]++;
    });
    return categorizedColumnCount;
  };

  const sheetSummary = () => {
    return (
      <SheetSummary
        fileName={fileName}
        fileDescription={fileDescription}
        isReadOnly={isReadOnly}
        fileSize={fileSize}
        fileRows={fileRows}
        columnCount={columnCount}
        columnsByType={countColumnTypes()}
        viewTypeOptions={[
          { id: 0, label: 'Chart', value: 'Chart', type: 'Chart' },
          { id: 1, label: 'Table', value: 'Table', type: 'Table' },
        ]}
        getTableLabel={(value) => getTableLabel(value)}
      />
    );
  };

  return (
    <div className='relative h-full overflow-scroll'>
      <div
        data-cy='header-text'
        className='sticky top-0 flex items-center w-full h-[41px] p-2 text-[15px] font-semibold gap-1 border-t border-b border-ui-200 bg-white'
      >
        <Icon name='lightbulb' size={20} />
        Sheet Info
      </div>
      <div>{sheetSummary()}</div>
    </div>
  );
};

export default SheetStats;
